import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b22de14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkbox-list" }

import { computed, ref } from "vue";
import TressCheckboxListItem from "./TressCheckboxListItem.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressCheckboxList',
  props: {
    options: {},
    modelValue: {},
    showMoreText: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }) {

const props = __props;





const _modelValue = computed({
  get: () => props.modelValue,
  set: (val: string[]) => {
    emits("update:modelValue", val);
  },
});

const expanded = ref(false);

const numberOfElements = computed(() => props.options.length);
const items = computed(() => {
  if (expanded.value) {
    return props.options;
  }
  return props.options.slice(0, 4);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (option) => {
      return (_openBlock(), _createBlock(TressCheckboxListItem, {
        key: option.value,
        modelValue: _modelValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_modelValue).value = $event)),
        label: option.label,
        value: option.value
      }, null, 8, ["modelValue", "label", "value"]))
    }), 128)),
    (numberOfElements.value > 4 && !expanded.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (expanded.value = true))
        }, _toDisplayString(_ctx.showMoreText), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})